import { OptionsValues } from "basis";
import { durationOfHardshipOptions } from "pages/HardshipApplication/options";

export const mapDurationOfHardshipToEventLabel: Record<
  Exclude<OptionsValues<typeof durationOfHardshipOptions>, "">,
  string
> = {
  hardship_arrangement_3_months: "3",
  hardship_arrangement_6_months: "6",
  hardship_arrangement_9_months: "9",
  hardship_arrangement_12_months: "12",
  hardship_arrangement_more_than_12_months: "12+",
};
